module.exports = __webpack_public_path__ + "static/media/jason.544fd8dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadImg/jason.jpg
// module id = 733
// module chunks = 0